import { User } from "../interfaces/user";

const initialState: User = {
  login: false,
  id: 0,
  sub: "",
  email: "",
  name: "",
  role: "user",
  isBarOpen: true,
  isCafeOpen: true,
};

export interface UserAction {
  type: string;
  payload: User;
}

export const userReducer = (
  state: User = initialState,
  action: UserAction
): User => {
  switch (action.type) {
    case "LOGIN":
      return action.payload;
    case "LOGOUT":
      return initialState;
    default:
      return state;
  }
};
